import { LogOut } from "lucide-react";
import SpotifyIcon from "../assets/spotify.svg?react";
import type { SpotifyPanelProps } from "../types/spotify";

export function SpotifyPanel({
  token,
  login,
  logout,
  track,
}: SpotifyPanelProps) {
  const hasTrack = !!(track && track.item);

  return (
    <section className="w-full rounded-xl border border-white/10 bg-black/20 p-2 text-white backdrop-blur-sm">
      {!token ? (
        <button
          onClick={login}
          className="flex w-full cursor-pointer items-center gap-3 rounded-lg border border-white/10 bg-white/[0.05] px-3 py-2 text-left text-white transition-colors hover:bg-white/[0.1]"
        >
          <SpotifyIcon className="size-6" />
          <span className="text-sm text-white/80">Connect Spotify</span>
        </button>
      ) : (
        <div className="flex items-center gap-3 p-1">
          {hasTrack ? (
            <img
              src={track.item.album.images[2]?.url}
              alt="track cover"
              className="size-14 shrink-0 rounded-md object-cover"
            />
          ) : (
            <div className="flex size-14 shrink-0 items-center justify-center rounded-md border border-white/10 bg-white/[0.05]">
              <SpotifyIcon className="size-6 opacity-75" />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-semibold text-white">
              {hasTrack ? track.item.name : "Spotify connected"}
            </div>
            <div className="mt-0.5 truncate text-sm text-white/60">
              {hasTrack ? track.item.artists.map((a: any) => a.name).join(", ") : "No track data"}
            </div>
          </div>
          <button
            onClick={logout}
            className="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-white/10 bg-white/[0.05] text-white/75 transition-colors hover:bg-white/[0.1] hover:text-white"
            title="Выход"
          >
            <LogOut className="size-5" />
            <span className="sr-only">Выход</span>
          </button>
        </div>
      )}
    </section>
  );
}
